import {
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from "@microsoft/signalr";
import { HubType, SignalRInfo } from "../services/negotiateService";
import RestResponse, { restError } from "../models/client/RestResponse";

export const createHubConnection = async (
  hub: HubType,
  negotiate: (hub: HubType) => RestResponse<SignalRInfo>
): Promise<HubConnection> => {
  const getSignalRInfo = async () => {
    const signalRInfo = await negotiate(hub);
    if (!signalRInfo.success) throw restError(signalRInfo);
    return signalRInfo.value;
  };

  const initialInfo = await getSignalRInfo();

  const connection = new HubConnectionBuilder()
    .withUrl(initialInfo.url, {
      accessTokenFactory: async () => {
        const info = await getSignalRInfo(); // Always fetch fresh token
        return info.accessToken;
      },
    })
    .configureLogging(LogLevel.Information)
    .withAutomaticReconnect()
    .build();

  return connection;
};
